const state = {
  isShowDebug: true,
  renderInfo: {},
  viewerConfig:  {},
  statsDom: {},
  timeText: '',
}

const mutations = {
  show(state) {
    state.isShowDebug = true
  },
  hide(state) {
    state.isShowDebug = false
  },
  updateRenderInfo(state, info){
    state.renderInfo = info;
  },
  updateConfig(state, config){
    state.viewerConfig = config
  },
  updateTime(state, text){
    state.timeText += text;
  }

}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
